/** @format */

import { getAPIUrls } from 'src/helpers';
import { IS_APP_IMMICHAT } from 'src/constants/constants.js';

const apiRootPaths = {
  SSO_URLS: 'https://auth-qa02.ey.com/samlp/4iQR3KQ3KeyPbyVuUhTNA7IdEG0RJ3P5?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://dev-pathway.ey.com/35',
  DASHBOARD_HEADER_COUNT: '/api/v1/dashboard/headerCount',
  DASHBOARD_CASE_PHASES: '/api/v1/casemanagement/getCasePhaseCard',
  DASHBOARD_CONTACTS: '/api/v1/dashBoard/getContactCardList',
  DASHBOARD_DOCUMENTS: '/api/v1/dashboard/getNewDocuments',
  DOCUMENTS_GET_DOCUMENTS: '/api/v1/documents/getdocuments',
  DOCUMENTS_UPLOAD: '/api/v1/documents/documentupload',
  DOCUMENTS_CLIENTS: '/api/v1/documents/getclients',
  DOCUMENTS_DOCUMENT_TYPES: '/api/v1/documents/getdocumentypes',
  DOCUMENTS_EMPLOYEES: '/api/v1/documents/getemployees',
  DOCUMENTS_FIELDS: '/api/v1/documents/getdocumentmetadatabydocumenttype',
  DOCUMENTS_SAVE_UPLOAD: '/api/v1/documents/savedocumentinformation',
  DOCUMENTS_GET_GROUP: '/api/v1/document/getdocumentgroup',
  DOCUMENTS_FILTER_ADMIN: '/api/v1/documents/filterAdmindocuments',
  DOCUMENTS_FILTER: '/api/v1/documents/filterdocuments',
  DOCUMENTS_GET_FILTERS: '/api/v1/documents/filters',
  DOCUMENT_GET_CHAT_HISTORY_PDF: '/api/v1/document/ConvertChatToPdf',
  DOCUMENTS_GET_SUPPORTED_FILE: '/api/v1/documents/getSupportedFileTypes',
  DOCUMENTS_OPEN: '/api/v1/documents/opendocument',
  MENU_DOCUMENTS_OPEN: '/api/v1/documents/openAdminDocument',
  DOCUMENTS_DELETE: '/api/v1/documents/deletedocument',
  DOCUMENTS_VIEW_DETAILS: '/api/v1/documents/getdocumentinformation',
  DOCUMENTS_SAVE_DOCUMENT_DETAIL: '/api/v1/documents/savedocumentinformation',
  DOCUMENTS_GET_SLADETAILS: '/api/v1/taxchat/getSLADetails',

  GET_DELIVERY_RETURN_IRCOUNTER: '/api/v1/taxchat/GetDeliverReturnIRCounter',
  MISSING_DOCUMENTS_SERVICE: '/api/v1/taxchat/updateMissingDocuments',
  ALL_DOCs_RECEIVED_SERVICE: '/api/v1/taxchat/updateAllDocsReceivedByEY',
  SAVE_OVERRIDE_EXTERNALSLA_SERVICE: '/api/v1/taxchat/saveOverrideExternalSLA',
  ENGAGEMENTS_LIST: '/api/v1/ssi/getengagementlist',
  GET_ENGAGEMENT_GROUP_SERVICE_URL: '/api/v1/engagement/GetEngagementGroups',
  ENGAGEMENT_GROUP_DETAIL_SERVICE_URL: '/api/v1/engagement/getEngagementGroupByEngagementGroupId?engagementGroupId=',
  GET_ENGAGEMENT_LIST_BY_GROUP_ID_SERVICE_URL: '/api/v1/engagement/getEngagementListByEngagementGroupId',
  SAVING_ENGAGEMENT_GROUP_SERVICE_URL: '/api/v1/engagement/SavingEngagementGroup',
  ENGAGEMENT_LIST_FOR_ADDING_ENGAGEMENT_GROUP_SERVICE_URL: '/api/v1/engagement/engagementListForAddingEngagementGroup',
  ADD_ENGAGEMENT_IN_ENGAGEMENT_GROUP_SERVICE_URL: '/api/v1/engagement/AddEngagementInEngagementGroup',
  REMOVE_ENGAGEMENT_FROM_ENGAGEMENT_GROUP_SERVICE_URL: '/api/v1/engagement/RemoveEngagementFromEngagementGroup',
  LOGIN_SERVICE: '/api/v1/auth/login',
  LOGIN_SSO_SERVICE: '/api/v1/auth/ssoLogin',
  LOGOUT_SERVICE: '/api/v1/auth/logout',
  FORGOT_PASSWORD_SERVICE: '/api/v1/users/forgot-password',
  PINCODE_SERVICE: '/api/v1/auth/two-way',
  PINCODE_FORGOT_PASS_SERVICE: '/api/v1/users/forgot_password/two-way',
  RESET_PASS_SERVICE: '/api/v1/users/forgot_password/reset',
  RESEND_CODE_SERVICE: '/api/v1/sendagain',
  USER_VALIDATE_SERVICE: '/api/v1/users/validate',
  MESSAGING_INBOX_SERVICE: '/api/v1/communications/inbox',
  MESSAGING_SENT_SERVICE: '/api/v1/communications/sent',
  MESSAGING_DRAFTS_SERVICE: '/api/v1/communications/drafts',
  MESSAGING_DETAILS_SERVICE: '/api/v1/communications/message',
  MESSAGING_SAVEMESSAGE_SERVICE: '/api/v1/communications/savemessage',
  MESSAGING_COUNT_SERVICE: '/api/v1/communications/count',
  MESSAGING_DELETE_SERVICE: '/api/v1/communications/delete',
  TEST_SERVICE: '/api/v1/sometest',
  DOWNLOAD_BINDER: '/api/v1/documents/DownloadBinderPBFX',
  CASES_UPDATE_EXTENSION_DETAILS: '/api/v1/casemanagement/updateExtensionDetails',
  CASES_GET_PRIMARY_CASE_CONTACTS: '/api/v1/casemanagement/getPrimaryCaseContacts',
  CASES_GET_SECONDARY_CASE_CONTACTS: '/api/v1/casemanagement/getSecondaryCaseContacts',
  CASES_GET_TERITARY_CASE_CONTACTS: '/api/v1/casemanagement/getTertiaryCaseContacts',
  CASES_GET_COE_MEMBER_CASE_CONTACTS: '/api/v1/casemanagement/getCOEMemberCaseContacts',
  CASES_UPDATE_RETURN_GROUP_DETAILS: '/api/v1/casemanagement/saveReturnGroupDetails',
  CASES_UPDATE_OTHER_DETAILS: '/api/v1/casemanagement/SaveCaseAdditionalInfoOtherDetails',
  CASES_UPDATE_PACE_DETAILS: '/api/v1/casemanagement/SaveCasePaceDetails',
  CASES_GET_DELEGATE_CASE_CONTACTS: '/api/v1/casemanagement/GetDelegateDetails',
  UPDATE_DELEGATE_PROFILE: '/api/v1/casemanagement/updateDelegateProfile',
  CASES_GET_CASES: '/api/v1/casemanagement/GetCases',
  CASES_GET_DASHBOARD_NEW_CASES: '/api/v1/casemanagement/GetNewCases',
  CASES_SERVICE_TYPE: '/api/v1/taxchat/getServiceListbyYear',
  CASES_GET_CASE_IDS: '/api/v1/casemanagement/case',
  CASES_GET_CASE_DETAIL: '/api/v1/casemanagement/GetCaseDetail',
  CASES_SAVE_CASE_DETAIL: '/api/v1/casemanagement/SaveCaseDetail',
  CASES_GET_QUESTIONNAIRE_LIST: '/api/v1/casemanagement/getQuestionnaireList',
  CASES_GET_DETAILS_HEADER: '/api/v1/casemanagement/getApplicantDetails',
  CASES_GET_LINKED_CASE_SHOWFLAG: '/api/v1/casemanagement/GetIsLinkedCasesShowFlag',
  CASES_GET_LINKED_CASE_LINKEDCASE: '/api/v1/casemanagement/GetLinkedCases',
  CASES_UPDATE_EXPERIAN_VALIDATED: '/api/v1/casemanagement/updateExperianValidated',
  LOBBYMESSAGE_GET_YEAR: '/api/v1/casemanagement/getYearList',
  GET_LANGUAGES_LOBBYMESSAGE: '/api/v1/getLanguages',
  UPDATE_LOBBY_MESSAGE: '/api/v1/taxchat/updateLobbyMessage',
  CASES_GET_FILTERS: '/api/v1/casemanagement/getfilters',
  CASES_GET_PATHWAYS: '/api/v1/casemanagement/getpathways',
  CASES_GET_CASE_PATHWAYS: '/api/v1/casemanagement/getcasepathway',
  CASES_SAVE_PATHWAYS: '/api/v1/casemanagement/saveCasePathway',
  CASES_UPDATE_CONTACT: '/api/v1/casemanagement/updateCaseContacts',
  CASES_GET_CASE_STATUS: '/api/v1/casemanagement/getCaseStatus',
  CASES_GET_QUESTIONNAIRE_ACCESS:'/api/v1/taxchat/getQuestionnaireAccess',
  CASES_GET_ONBOARDING_METHOD: '/api/v1/taxchat/getOnboardingMethod',
  CASES_UPDATE_QUESTIONNAIRE_ACCESS: '/api/v1/casemanagement/UpdateCaseQuestionnaireAccess',
  CASES_GET_ADDITIONALINFO: '/api/v1/casemanagement/getCaseAdditionalInfo',
  CASES_UPDATE_ISPRIMARY: '/api/v1/casemanagement/UpdateRelatedReturn',
  CASES_UPDATE_DELEGATE: '/api/v1/casemanagement/updateDelegateProfile',
  CASES_UPDATE_STATUS: '/api/v1/casemanagement/updateCaseStatus',
  CONSENT_UPDATE_STATUS: '/api/v1/casemanagement/updateCaseConsentStatus',
  CASES_UPDATE_FREQUENCY: '/api/v1/casemanagement/updatecasechasefrequency',
  CASES_UPDATE_MANAGER_STATUS: '/api/v1/casemanagement/updateCaseStatusOnHold',
  CASES_UPDATE_ALLOWED_ACCESS: '/api/v1/casemanagement/updateClientAllowedAccess',
  CASES_UPDATE_TAXDAY: '/api/v1/casemanagement/updateTaxDay',
  CASES_UPDATE_CASE_PHASE: '/api/v1/casemanagement/updateCasePhase',
  CASES_CASE_PHASES: '/api/v1/casemanagement/casephase',
  CASES_GET_EYSTATUS: '/api/v1/casemanagement/getCasePhaseEYStatus',
  GET_TAXCADDY_LOGS_LIST: '/api/v1/taxchat/GetTaxCaddyLogs',
  SET_TAXCADDY_SUBSCRIBE: '/api/v1/taxchat/TaxCaddySubscribe',
  SET_TAXCADDY_UNSUBSCRIBE: '/api/v1/taxchat/TaxCaddyUnSubscribe',
  CASES_DOWNLOAD_ANSWERKEY: '/api/v1/cms/caseanswerkeyXML?caseManagerId=',
  CASES_CS_DOWNLOAD_ANSWERKEY: '/api/v1/cms/downloadCSAnswerKeyXML',
  CASES_DELIVER_RETURN: '/api/v1/documents/GetCCHDocuments',
  CASES_DELIVER_RETURN_PRICE_DETAIL: '/api/v1/taxchat/GetDeliverRedeliverReturnPricePrompt',
  CASES_RESET_BINDER_CREATE: '/api/v1/taxchat/resetBinderCreation',
  CASES_RESET_DOCUMENTS_UPLOAD: '/api/v1/taxchat/resetSurePrepDocumentsUpload',
  CASES_FILTER_CASE_PHASES: '/api/v1/casemanagement/GetCasePhaseByCountryYearServiceType',
  CASES_FILTER_GET_EYSTATUS: '/api/v1/casemanagement/GetEYStatusPhaseByCountryYearServiceType',
  CASES_COUNTRY_GET_CASEYEAR: '/api/v1/casemanagement/getCountryListServiceListOnSelectedYear',
  CASES_GET_YEAR_BYCOUNTRY: '/api/v1/casemanagement/getYearListOnSelectedCountry',
  CASES_GETLOBBYMESSAGE: '/api/v1/taxchat/getLobbyMessageByProductTypeAbAndLanguageId',
  CASES_PRODUCT_TYPE_YEAR_COUNTRY: '/api/v1/taxchat/getProductTypeBySelectedCountry',
  CASES_PHASE_EYSTATUS_COUNTRYYEARSERVICE: '/api/v1/casemanagement/GetCasePhaseandEYStatusByCountryYearServiceType',
  AUTOCOMPLETE_EMAIL_SERVICE: '/api/v1/communications/search',
  AUTOCOMPLETE_CASEMANAGER_SERVICE: '/api/v1/communications/searchcasemanager',
  AUTOCOMPLETE_CMS_FILE_SERVICE: '/api/v1/administration/searchUploads',
  ADMIN_GET_FILES: '/api/v1/cms/GetCMSPackageResult',
  ADMIN_UPLOAD_CMS_SERVICE: '/api/v1/cms/UploadCMSPackageFile',
  ADMIN_UPLOAD_TAXCHATXML_SERVICE: '/api/v1/taxchat/UploadTaxChatConfigPackageFile',
  ADMIN_UPLOAD_TAXCHAT_ID_PARAM_SERVICE: '/api/v1/taxchat/uploadIDParametersFile',
  ADMIN_DOWNLOAD_CASETEMPLATE_SERVICE: '/api/v1/taxchat/downCaseTemplate',
  ADMIN_DOWNLOAD_PREREGISTER_APPLICANT_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadPreRegisterTemplate',
  ADMIN_DOWNLOAD_PREREGISTER_DELEGATE_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadPreRegisterDelegateTemplate',
  ADMIN_DOWNLOAD_EY_COMPETENCY_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadCompetencySetupTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_STATUS_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUpdateStatusTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_CASE_CONTATCS_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUpdateOfCaseContactTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_OTHER_DETAILS_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUpdateOtherDetailsTemplate',
  ADMIN_SELECT_TYPEOFIMPORT_DROPDOWN: '/api/v1/taxchat/fillImportType',
  ADMIN_DOWNLOAD_PREREGISTER_LINKING_UPDATING_DELEGATE_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadDelegateLinkingTemplate',
  ADMIN_DOWNLOAD_PREREGISTER_LINKING_DELINKING_CASES_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadLinkingDelinkingCasesTemplate',
  ADMIN_DOWNLOAD_PREREGISTER_OVERVIEW_CASES_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadOverViewTemplate',
  ADMIN_DOWNLOAD_PREREGISTER_LINKING_CASES_WITH_PRIMARY_ID_SERVICE: '/api/v1/taxchat/downloadPreRegisterCasesWithPrimaryIdTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_CASEPHASE_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUploadCasePhasesTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_DOCTYPE_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUploadDocSyncTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_CONSENT_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUploadConsentManagementTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_APPLICANT_ENGAGEMENT_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUploadApplicantEngagementTemplate',
  ADMIN_DOWNLOAD_EY_BULK_APPLICANT_DELETION_TEMPLATE: '/api/v1/taxchat/downloadBulkUploadApplicantDeletionTemplate',
  ADMIN_DOWNLOAD_EY_USER_PROFILE_CREATION_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkCreateAdminProfileTemplate',
  ADMIN_DOWNLOAD_EY_USER_PROFILE_UPDATION_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUpdateAdminProfileTemplate',
  ADMIN_DOWNLOAD_EY_USER_CONTACT_SETUP_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkAdminProfileEyContactTemplate',
  MOVEAPPLICANT_CASES_GET_CASES: '/api/v1/casemanagement/GetCasesForApplicantMovement',
  SAVE_MOVE_APPLICANT: '/api/v1/taxchat/MoveApplicant',
  ADMIN_UPLOAD_DROPDOWNS_CMS_SERVICE: '/api/v1/cms/GetDropDownValuesForUploadCMSPackageFile',
  ADMIN_DROPDOWNS_CMS_SERVICE: '/api/v1/cms/GetDropDownValuesForCMSPackageResult',
  ADMIN_UPDATE_CMS_SERVICE: '/api/v1/cms/UpdatePackageMetaData',
  ADMIN_GET_FILE_CATEGORY_SERVICE: '/api/v1/cms/GetDropDownValuesForUploadCMSPackageFile',
  SSI_GET_LIST: '/api/v1/ssi/getssilist',
  SSI_GET_ENGAGEMENTLIST: '/api/v1/ssi/getengagementlist',
  SSI_GET_INITIATIONTYPELIST: '/api/v1/ssi/getinitiationtypelist',
  SSI_GET_EMPLOYEELIST_BY_NAME: '/api/v1/ssi/getemployeelistbyname',
  SSI_GET_PASSPORT_COUNTRYLIST: '/api/v1/ssi/getpassportcountrylist',
  SSI_GET_RELATIONSHIPSTATUS_LIST: '/api/v1/ssi/getrelationshipstatus',
  SSI_GET_EMPLOYEETYPE_LIST: '/api/v1/ssi/getemployeetypelist',
  SSI_GET_SERVICETYPE_LIST: '/api/v1/ssi/getservicetypelist',
  SSI_GET_COUNTRY_LIST: '/api/v1/ssi/getcountrylist',
  SSI_GET_EMPLOYEELIST_FORDROPDOWN: '/api/v1/ssi/getemployeelistForDropdown',
  SSI_GET_DETAILS: '/api/v1/ssi/ssiServiceEmployeeDetails',
  SSI_ADD_NEWEMPLOYEE: '/api/v1/ssi/addNewEmployee',
  SSI_EXPORT: '/api/v1/ssi/exportssilist',
  SSI_GET_FILTERS: '/api/v1/ssi/getFilters',
  CMS_CREATE_SSIORGRANIZER: '/api/v1/cms/CreateSSIOrganizer',
  CMS_PERSIST_ORGANIZER: '/api/v1/cms/wpPersistOrganizer',
  CMS_SUBMIT_ORGANIZER: '/api/v1/cms/wpForceSubmitOrganizer',
  CMS_GET_SHOWORGANIZER: '/api/v1/cms/wpShowOrganizer',
  CMS_FILE_UPLOAD: '/api/v1/cms/SaveAttachment',
  CMS_FILE_REMOVE: '/api/v1/cms/RemoveAttachment',
  CMS_FILE_DOWNLOAD: '/api/v1/cms/DownloadDocument',
  CMS_SAVE_GOACCESS_DETAILS: '/api/v1/cms/SaveGOAccessDetails',
  CMS_PDF_DOWNLOAD: '/api/v1/cms/DownloadPDFDocument',
  CMS_XML_DOWNLOAD: '/api/v1/cms/wpDataDownloadAnswerkeyXML',
  CMS_REASSIGNCASE: '/api/v1/cms/reassignCase',

  ADMIN_GET_PACKAGE_FILE: '/api/v1/cms/cmsDownloadPackageFile',
  ADMIN_GET_STATUS_FILE: '/api/v1/cms/cmsDownloadStatusFile',
  MESSAGING_UPLOAD_ATTACHMENT_SERVICE: '/api/v1/communications/Upload',
  MESSAGING_SAVECASEMANAGERID_SERVICE: '/api/v1/communications/saveCaseManagerid ',
  MESSAGING_DOWNLOAD_ATTACHMENT_SERVICE: '/api/v1/communications/files',
  SAMPLE_TABLE_DATA: '',
  QUESTIONNAIRE_GET_CARD: '/api/v1/cms/questionnaireCard',
  QUESTIONNAIRE_GET_INTRO: '/api/v1/cms/wpQuestionnaireIntro',
  QUESTIONNAIRE_GET_SECTION: '/api/v1/cms/wpGetMenusPerSection',
  QUESTIONNAIRE_DOWNLOAD: '/api/v1/cms/wpDownloadOrganizerSummaryAsPDF',
  CONSENT_MANAGEMENT_FETCH_DATA: '/api/v1/consents/GetAdminConsentDetails',
  CONSENT_MANAGEMENT_FETCH_FILTERS: '/api/v1/consents/GetAdminConsentDetailFilters',
  CONSENT_MANAGEMENT_FETCH_BANNER: '/api/v1/consents/GetAdminConsentBannerDetails',
  CONSENT_MANAGEMENT_FETCH_TAB_DATA: '/api/v1/consents/GetAdminConsentVersionDetails',
  CONSENT_MANAGEMENT_DOWNLOAD_DETAILS: '/api/v1/consents/downloadAdminConsentDetails',
  CONSENT_GET_BY_DEF_KEY: '/api/v1/consents/getConsentsByConsentDefinitionKey',
  CONSENT_SAVE_ACCEPTANCES: '/api/v1/consents/saveConsentAcceptances',
  CONSENT_DOWNLOAD_SUMMARY: '/api/v1/consents/downloadConsentsSummary',
  USERS_GET_ALL: '/api/v1/users/getUsers',
  USERS_GET_ENGAGEMENT_OPTIONS: '/api/v1/users/getEngagements',
  USERS_GET_USERDETAIL: '/api/v1/users/getUserDetails?profileKey=',
  USERS_GET_SYSTEMROLES: '/api/v1/users/getRoles',
  USERS_GET_COUNTRY_LIST: '/api/v1/users/getCountries',
  USERS_USER_DETAIL_SAVE: '/api/v1/users/saveuser',
  USERS_DELETE_PROFILE: '/api/v1/taxchat/DeleteProfile',
  ENGAGEMENTS_GET_ALL: '/api/v1/engagement/getEngagements',
  //ENGAGEMENTS_GET_DETAILS: 'api/v1/engagement/getEngagementDetails?profileKey=',
  ENGAGEMENTS_SAVE_DETAILS: '/api/v1/engagement/saveEngagement',
  ENGAGEMENTS_GET_DETAILS: '/api/v1/engagement/getEngagementDetails?engagementApplicationEnvironmentKey=',
  ENGAGEMENTS_GET_USERS: '/api/v1/engagement/searchEngagementUsers/',
  ENGAGEMENT_TEAMS_LIST_DETAILS: '/api/v1/engagement/getTeamlistByEngagement',
  EXPERIAN_VALIDATED_LIST: '/api/v1/taxchat/getExperianValidatedList',
  GET_SLATYPE_LIST: '/api/v1/engagement/getSLATriggerQuestionnaireList',
  ENGAGEMENTS_SAVE_USERS: '/api/v1/engagement/saveUsersEngagement',
  ENGAGEMENTS_TEAM_USERS_DETAILS: '/api/v1/engagement/getUserlistByEngagement',
  ENGAGEMENT_USER_COUNTRY_LIST: '/api/v1/users/getCountries',
  ENGAGEMENT_TEAM_SAVE_DETAILS: '/api/v1/engagement/saveTeamDetails',
  ENGAGEMENT_TEAM_GET_DETAILS: '/api/v1/engagement/getEngagementTeamDetails',
  ENGAGEMENT_SEARCH_TEAM_MEMBER: '/api/v1/engagement/searchEngagementTeamMember',
  ENGAGEMENT_SEARCH_TEAM_COUNTRY: '/api/v1/engagement/getCountriesByTeamEngagementKey',
  ENGAGEMENT_DATA_ACCESS_GROUP_DETAILS: '/api/v1/engagement/getApplicationEngagementDataAccessGroup',
  FETCH_CASE_FREQUENCY_LIST: '/api/v1/taxchat/getChaseFrequency',
  FETCH_SLA_QUESTIONNAIRE_LIST: '/api/v1/engagement/getSLATriggerQuestionnaireList',
  GET_WORKPAPER_URL: '/api/v1/cms/GenerateWorkPaperURL',
  GET_CHATS_BY_CASEMGRID: '/api/v1/taxchat/getChatDetails',
  SAVE_CHATS_BY_CASEMGRID: '/api/v1/taxchat/saveChat',
  GET_UNREADS_CHAT_COUNT_CASEMGRID: '/api/v1/taxchat/getUnreadChatCount',
  MARK_READUNREAD_CHATS: '/api/v1/taxchat/chatRead',
  DELETE_CHAT: '/api/v1/taxchat/chatDelete',
  EDIT_CHAT: '/api/v1/taxchat/chatEdit',
  RAISED_TO_TECH_CHATS: '/api/v1/taxchat/raiseToTechnology',
  SIGNER_ACTION_REQUIRED: '/api/v1/taxchat/signerActionRequired',
  MISSING_ITEM_REQUESTED: '/api/v1/taxchat/missingItemRequested',
  INCORPORATE_INTO_RETURN: '/api/v1/taxchat/incorporateIntoReturn',
  GET_PRODUCT_LIST_BY_ORG_YEAR: '/api/v1/cms/getProductListByOrganizerTypeAndYear/',
  CREATE_TAXCHAT_QUESTIONNAIRE: '/api/v1/taxchat/createTaxChatQuestionnaire',
  DOWNLOAD_PREPROFORMA_XML: '/api/v1/cms/downloadpreproformaXML',
  DOWNLOAD_ANSWERKEY_XML: '/api/v1/cms/downloadanswerkeyXML',
  DOWNLOAD_ORGANIZER_SUMMARY: '/api/v1/cms/wpDownloadOrganizerSummaryAsPDF',
  GET_CASE_MANAGER_ID_BY_PROFILE_KEY: '/api/v1/casemanagement/getCaseManagerIdByProfileKey',
  GET_APP_VERSION_BY_PLATFORM_ID: '/api/v1/taxchat/getAppVersionByPlatformId',
  UPDATE_APP_VERSION: '/api/v1/taxchat/updateAppVersion',
  CASE_UPLOAD_GET_CASES: '/api/v1/taxchat/getImportJobResult',
  PREREGISTER_UPLOAD_GET_LOGS: '/api/v1/taxchat/getImportJobPreRegisterResult',
  CASE_UPLOAD_GET_FILTERS: '/api/v1/casemanagement/getfilters',
  CASE_UPLOAD: '/api/v1/taxchat/CreateCaseUsingImport',
  PREREGISTER_USER_UPLOAD: '/api/v1/taxchat/preRegisterUserUsingImport?importTypeId=1880',
  SAVE_CASE_UPLOAD: '/api/v1/taxchat/UpateCaseImportStatus',
  DOWNLOAD_ZIPALLDOCUMENTS: '/api/v1/documents/zipAllDocuments',
  EXECUTE_SP_API: '/api/v1/documents/ExecuteOnDemandSurePrepAPI',
  SAVE_OTHER_REQUEST_DOCUMENTS: '/api/v1/documents/saveOtherRequiredDocuments',
  SAVE_PREREGISTER_USER_UPLOAD: '/api/v1/taxchat/upatePreRegisterUserStatus',
  IMPORT_JOB_GET_STATUS_FILE: '/api/v1/taxchat/downloadImportJobStatusFile',
  PREREGISTER_GET_STATUS_FILE: '/api/v1/taxchat/downloadPreRegisterStatusFile',
  GET_CONSENT_FOR_EYUSER: '/api/v1/consents/getConsentForEYUser',
  CASES_UPDATE_DELEGATE_CONSENT: '/api/v1/consents/saveDelegateConsentForEYUser',
  DOWNLOAD_CONSENT_FOR_EYUSE: '/api/v1/consents/downloadConsentForEYUse',
  OPEN_CONSENT_DOCUMENT: '/api/v1/consents/downloadConsentForEYUser',
  PROFORMA_UPLOAD_GET_CASES: '/api/v1/taxchat/getExternalProformaImportResult',
  PROFORMA_UPLOAD_GET_FILTERS: '/api/v1/casemanagement/getfilters',
  PROFORMA_UPLOAD: '/api/v1/taxchat/uploadExternalProformaImportFile',
  SAVE_PROFORMA_UPLOAD: '/api/v1/taxchat/updateExternalProformaImportStatus',
  TAXCHAT_SERVICE_INITIATION_GET_FILTERS: '/api/v1/taxchat/getServiceRequestInitiationFilters',
  TAXCHAT_SERVICE_INITIATION_GET_REQUESTS: '/api/v1/taxchat/getServiceInitiationRequests',
  TAXCHAT_SERVICE_INITIATION_GET_DETAIL: '/api/v1/taxchat/getServiceRequestDetails',
  TAXCHAT_SERVICE_INITIATION_UPDATE_ACTION: '/api/v1/taxchat/UpdateServiceRequestDetails',
  IMPORT_PROFORMA_JOB_GET_STATUS_FILE: '/api/v1/taxchat/downloadExternalProformaStatusFile',
  GET_EXPERIAN_RESULTS: '/api/v1/experian/getExperianResult',
  GET_EXPERIAN_BGCHECK_RESULTS: '/api/v1/experian/getBackgroundCheckTestRecords',
  GET_EXPERIAN_PDF: '/api/v1/experian/getExperianPDF',
  GET_EXPERIAN_TEXT_TO_PDF: '/api/v1/experian/GetExperianTestExportToPDF',
  GET_PERSON_PROFILE_PDF_BY_RESCODE: '/api/v1/experian/getPersonProfilePdfByResourceId?resourceId=',
  UPDATE_BG_CHECK_DETAIL: '/api/v1/experian/updateBackgroundCheckDetail',
  GET_ID_DOCUMENTLIST: '/api/v1/experian/getiddocumentlist',
  UPLOAD_ID_DOCUMENTIMAGES: '/api/v1/experian/uploadIDDocumentImages',
  UPLOAD_ID_VALIDATORFILE: '/api/v1/taxchat/ValidateUploadedFile',
  DOWNLOAD_EXPERIAN_JSON: '/api/v1/experian/downloadexperianJson/',
  SET_DOCUMENT_RECEIVED: '/api/v1/documents/updateCaseDocumentTypeByAdmin',
  SET_ACKNOWLEDGE_DOCUMNET: '/api/v1/documents/acknowledgeDocument',
  GET_EXPERIAN_SERVICETYPE: '/api/v1/experian/getExperianServiceTypes',
  SEARCH_EXPERIAN_MANUAL_REQUESTQUEUE: '/api/v1/experian/searchExperianManualRequestQueue',
  GET_POLLING_DETAILS: '/api/v1/experian/getPollingDetails',
  RETRIEVE_MANUAL_REQUEST_RESULT: '/api/v1/experian/retrieveManualRequestResult',
  DEL_EXPERIAN_MANUAL_REQUEST_QUEUE: '/api/v1/experian/delExperianManualRequestQueue',
  GET_AUTIDT_LOG_REPORT_LIST: '/api/v1/cms/wpGetAuditLogReportList',
  ADDRESS_LOOKUP: '/api/v1/taxchat/getAddressLookUp',
  INITIATE_EFILE_STATUS: '/api/v1/casemanagement/initiateEFile',
  INITIATE_DOCUSIGN_STATUS: '/api/v1/taxchat/resetEnvelopeCreation',
  FAVORITE_MARK: '/api/v1/casemanagement/UpsertUserFavoriteCase',
  DASHBOARD_FAVORITE_TABLE: '/api/v1/casemanagement/GetAllFavoriteCase',
  DASHBOARD_RECENT_CASES_TABLE: '/api/v1/casemanagement/GetRecentCases',
  POWERBI_EMBED: '/api/v1/taxchat/PowerBIEmbedToken',
  UPDATE_SP_STATUS_DATE: '/api/v1/casemanagement/UpdateSPStatusDate',
  SYNC_SUREPREP_BINDER: '/api/v1/taxchat/SureprepStatusSyncManually',
  DELETE_CASE: '/api/v1/taxchat/deleteCase',
  GET_PAYWALL_REQUEST_DROPDOWN: '/api/v1/taxchat/GetDropDownValuesForPaymentRequest',
  PROCESS_PAYMENT_REQUEST: '/api/v1/taxchat/ProcessPaymentRequest',
  GET_PAYMENT_REQUEST_RESULT: '/api/v1/taxchat/GetPaymentRequestResult',
  GET_DELETEDPROFILE_LOGS: '/api/v1/taxchat/downloadDeletedProfileLogs',
  GET_MASTER_VALUES_FOR_ENGAGEMENT: '/api/v1/engagement/getMasterValuesForEngagement',
  START_RESUME_BUTTON: '/api/v1/taxchat/StartResumeSLAByAdmin',  
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_MISSING_INFORMATION_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUploadMissingInfoTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_EXTENSION_DETAILS_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUploadExtensionDetailsTemplate',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_SI_DETAILS_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUploadSIDetailsEngagementTemplate',
  GET_MISSING_INFORMATION:'/api/v1/taxchat/GetMissingInformation',
  ADD_MISSING_INFORMATION_DIALOG:'/api/v1/taxchat/addMissingInfoDetails',
  SET_SUREPREP_OCR: '/api/v1/taxchat/SaveStopSurePrepOCR',
  OVERVIEW_GET_FILTERS: '/api/v1/casemanagement/GetOverviewFilters',
  OVERVIEW_GET_CASES: '/api/v1/casemanagement/GetOverviewCases',
  OVERVIEW_CASES_GET_DETAILS_HEADER: '/api/v1/casemanagement/getOverviewBanner',
  OVERVIEW_CASES_GET_REPRESENTATIVE_DETAILS: '/api/v1/casemanagement/GetOverviewContactDetails',
  OVERVIEW_SERVICE_REP_CASES_UPDATE_CONTACT: '/api/v1/casemanagement/SaveOverviewServiceRepresentative',
  OVERVIEW_GET_ADDITIONALINFO_DETAILS: '/api/v1/casemanagement/GetOverviewAdditionalInformation',
  OVERVIEW_UPDATE_ADDITIONALINFO_DETAILS: '/api/v1/casemanagement/SaveOverviewAdditionalInformation',
  OVERVIEW_GET_OPEN_CASES_DETAILS: '/api/v1/casemanagement/GetOpenCasesForOverview',
  OVERVIEW_DOCUMENTS: '/api/v1/documents/filterOverViewDocuments',
  OVERVIEW_UPDATE_DOCUMENT_RELATEDTO:'/api/v1/documents/updateModuleLinkIdByDocumentId',
  SET_FOLLOW_UP_ACKNOWLEDGE: '/api/v1/documents/acknowledgeMissingInfo',
  CONVERT_MISSING_INFO_TO_PDF: '/api/v1/document/ConvertMissingInfoToPdf',
  UPDATE_ONHOLD_RESPONSE_BY: '/api/v1/casemanagement/UpdateCaseOnholdResponseBy',
  UPDATE_RETURN_APPROVAL_BY: '/api/v1/casemanagement/updateReturnApprovalBy',
  UPDATE_CASE_PAYMENT_DETAILS: '/api/v1/casemanagement/UpdateCasePaymentDetails',
  UPDATE_ONBOARDING_METHOD: '/api/v1/casemanagement/UpdateCaseOnboardingMethod',
  ADMIN_DOWNLOAD_EY_BULK_UPDATE_REQUIRED_DOCUMENTS_TEMPLATE_SERVICE: '/api/v1/taxchat/downloadBulkUpdateRequiredDocumentsTemplate',
  SAVE_MISSING_INFORMATION:"/api/v1/documents/saveMissingInfoDetails",
  EDIT_MISSING_INFO_QUESTION: "/api/v1/taxchat/editMissingInfoQuestion",
  ADD_MISSING_INFO_NESTED_QUESTION_FOLLOW_UP: "/api/v1/taxchat/addMissingInfoNestedQuestion",
  DELETE_MISSING_INFO_QUESTION: "/api/v1/taxchat/deleteMissingInfoQuestion"
};
const apiHosts = {
  azure: {
    host: 'https://imlapp.azurewebsites.net/IML',
  },
  azureDEV: {
    host: IS_APP_IMMICHAT ? 'https://dev-immichat-api.ey.com/immichatapi' : 'https://dev-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/4iQR3KQ3KeyPbyVuUhTNA7IdEG0RJ3P5?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://dev-pathway.ey.com/35',
    },
  },
  azureQA: {
    host: IS_APP_IMMICHAT ? 'https://qa-immichat-api.ey.com/immichatapi' : 'https://qa-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/wuTSKcJqDNSRoCZl4fSDuRYNPxKIzZV2?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://qa-pathway.ey.com/67',
    },
  },
  azureUAT: {
    host: IS_APP_IMMICHAT ? 'https://uat-immichat-api.ey.com/immichatapi' : 'https://uat-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/6rim2VPyWQElYpcIc4pCEQh76gwnRBRa?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://uat-pathway.ey.com/14',
    },
  },
  azureDEV2: {
    host: IS_APP_IMMICHAT ? 'https://dev-immichat-api.ey.com/immichatapi' : 'https://dev2-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/wL6DH4B5nmue1j2STAM1dCIMAbYnyUiG?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://dev2-pathway.ey.com/35/',
    },
  },
  azureQA2: {
    host: IS_APP_IMMICHAT ? 'https://qa-immichat-api.ey.com/immichatapi' : 'https://qa2-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/0Vo3dVP6zp50niA3OdLGgDt2e97esmsd?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://qa2-pathway.ey.com/67/',
    },
  },
  azureUAT2: {
    host: IS_APP_IMMICHAT ? 'https://uat-immichat-api.ey.com/immichatapi' : 'https://uat2-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/rdAJ4AP7VyKiGwLT17xHE7siQIdDUT12?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://uat2-pathway.ey.com/14',
    },
  },
  local: {
    host: 'http://localhost/IML.API/',
    overrides: {
      TEST_SERVICE: 'http://someotherurl.com/api/v1/sometest',
    },
  },
  qa: {
    host: IS_APP_IMMICHAT ? 'https://dev-immichat-api.ey.com/immichatapi' : 'https://dev-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/wuTSKcJqDNSRoCZl4fSDuRYNPxKIzZV2?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://qa-pathway.ey.com/67',
    },
  },
  DEV1: {
    host: IS_APP_IMMICHAT ? 'https://dev-immichat-api.ey.com/immichatapi' : 'https://iml-app.eydev.net/IML',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/4iQR3KQ3KeyPbyVuUhTNA7IdEG0RJ3P5?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://dev-pathway.ey.com/35',
    },
  },
  DEV2: {
    host: IS_APP_IMMICHAT ? 'https://dev-immichat-api.ey.com/immichatapi' : 'https://iml-app.eydev.net/IML_DEV',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/wL6DH4B5nmue1j2STAM1dCIMAbYnyUiG?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://dev2-pathway.ey.com/35/',
    },
  },
  QA1: {
    host: IS_APP_IMMICHAT ? 'https://qa-immichat-api.ey.com/immichatapi' : 'https://iml-app.eyqa.net/IML',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/wuTSKcJqDNSRoCZl4fSDuRYNPxKIzZV2?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://qa-pathway.ey.com/67',
    },
  },
  QA2: {
    host: IS_APP_IMMICHAT ? 'https://dev-immichat-api.ey.com/immichatapi' : 'https://iml-app.eydev.net/IML',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/0Vo3dVP6zp50niA3OdLGgDt2e97esmsd?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://qa2-pathway.ey.com/67/',
    },
  },
  UAT1: {
    host: IS_APP_IMMICHAT ? 'https://uat-immichat-api.ey.com/immichatapi' : 'https://uat-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/6rim2VPyWQElYpcIc4pCEQh76gwnRBRa?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://uat-pathway.ey.com/14',
    },
  },
  UAT2: {
    host: IS_APP_IMMICHAT ? 'https://uat-immichat-api.ey.com/immichatapi' : 'https://uat2-taxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/rdAJ4AP7VyKiGwLT17xHE7siQIdDUT12?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://uat2-pathway.ey.com/14',
    },
  },
  STG: {
    host: IS_APP_IMMICHAT ? 'https://stg-immichat-api.ey.com/immichatapi' : 'https://stg-globaltaxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/oiIczrTQC7wCC2NOKIVQU8QEOShyihDA?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://stg-pathway.ey.com/6',
    },
  },
  EUSTG: {
    host: IS_APP_IMMICHAT ? 'https://stg-immichat-api.ey.com/immichatapi' : 'https://eustg-pathway.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://auth-qa02.ey.com/samlp/oiIczrTQC7wCC2NOKIVQU8QEOShyihDA?connection=EYGS-MEMBER-INTERNALUSERS&RelayState=https://stg-pathway.ey.com/6',
    },
  },
  PROD: {
    host: IS_APP_IMMICHAT ? 'https://immichat-api.ey.com/immichatapi' : 'https://globaltaxchat.ey.com/IMLAPI',
    overrides: {
      SSO_URLS: 'https://accessidp.idaas.ey.net/idp/startSSO.ping?PartnerSpId=CPSINSIGHTS&TARGET=https://pathway.ey.com/3/',
    },
  },
  DEMO: {
    host: 'https://demo-pathway.ey.com/IMLAPI',
  },
};

const { host, overrides } = apiHosts[process.env.TARGET_ENV];
const serviceURLS = getAPIUrls(host, apiRootPaths, overrides);

export { host, apiRootPaths };
export default serviceURLS;
